import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ConfigurationTable_ConfigurationFragment } from '../__generated__/ConfigurationsTable.graphql';

export function CreatedOnCell({
  value,
}: PropsWithChildren<CellProps<ConfigurationTable_ConfigurationFragment, string>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontWeight="semibold">
      {value}
    </Box>
  );
}

CreatedOnCell.graphql = {
  fragments: {
    CreatedOnCell_powerSchedule: gql`
      fragment CreatedOnCell_configuration on ConfigurationModel {
        id
        createdAt
      }
    `,
  },
};
